<div class="aayn-create-ad--header" [ngClass]="classes">
  <div class="aayn-create-ad--header--adtype">
    <div class="aayn-create-ad--header--adtype__name" *ngIf="url">{{ url }}</div>
  </div>
</div>
